import {createSelector} from "reselect";

const reports = (state) => state.reports;

export const getTemplateControllerList = createSelector(
  reports,
  (data) => data.templateControllerList || []
);

export const getTestSensorsList = createSelector(
  reports,
  (data) => data.testSensorsList || []
);

export const getNonTestTemplateList = createSelector(
  reports,
  (data) => data.nonTestTemplateList || []
);

export const getNonTestFormVisiability = createSelector(
  reports,
  (data) => data.isNonTestFormVisible
);

export const getTestTemplateList = createSelector(
  reports,
  (data) => data.testTemplateList || []
);

export const getTemplateListData = createSelector(
  reports,
  (data) => data.templateListData || {}
);

export const getTemplateList = createSelector(getTemplateListData, (data) => {
  if (data?.results?.length > 0) {
    return data?.results.map((template) => ({
      ...template,
      appliance: template.appliance.label,
    }));
  } else {
    return [];
  }
});

export const getTestFormVisiability = createSelector(
  reports,
  (data) => data.isTestFormVisible
);

export const getCreateTestData = createSelector(
  reports,
  (data) => data.createTestData || {}
);

export const getCreateNonTestData = createSelector(
  reports,
  (data) => data.createNonTestData || {}
);

export const getCreateTemplateData = createSelector(
  reports,
  (data) => data.createTemplateData || {}
);

export const getReportSites = createSelector(reports, (data) => data.reportSites || []);

export const getReportLocations = createSelector(
  reports,
  (data) => data.reportLocations || []
);

export const getReportControllers = createSelector(
  reports,
  (data) => data.reportControllers || []
);

export const getSelectedControllerList = createSelector(
  reports,
  (data) => data.selectedControllerList || []
);

export const getCreateReportData = createSelector(
  reports,
  (data) => data.reportFormData || {}
);

export const getReportsList = createSelector(reports, (reports) => {
  if (reports?.reportsData?.results?.length > 0) {
    return reports.reportsData.results.map((report) => ({
      ...report,
      isSubmitted: report.status === "submitted",
      inDraft: report.status === "draft",
      underReview: report.status === "under-review",
    }));
  } else {
    return [];
  }
});

export const getSeedDetails = createSelector(reports, (reports) => ({
  templates: reports.templateLabelValue,
  inventories: reports.inventoryLabelValue,
}));
